<template>
  <svg version="1.2" class="pencil" baseProfile="tiny-ps" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23" width="23" height="23">
    <g id="Button">
      <path id="Forma 1" class="shp0" d="M1.05 22.89L1.2 22.89L8.54 21.3C8.68 21.27 8.81 21.2 8.92 21.11L21.35 8.67C22.25 7.76 22.76 6.53 22.75 5.25C22.75 3.96 22.25 2.71 21.35 1.79C20.44 0.88 19.21 0.37 17.93 0.38C16.64 0.37 15.4 0.89 14.51 1.83L2.11 14.26C2 14.35 1.93 14.47 1.89 14.6L0.29 21.94C0.25 22.21 0.33 22.47 0.52 22.66C0.66 22.81 0.85 22.89 1.05 22.89ZM17.93 1.9C19.75 1.9 21.23 3.38 21.23 5.21C21.23 5.22 21.23 5.24 21.23 5.25C21.25 6.12 20.9 6.96 20.28 7.57L15.61 2.85C16.22 2.24 17.06 1.9 17.93 1.9ZM14.54 3.96L19.22 8.63L8.39 19.43L3.71 14.79L14.54 3.96ZM3.1 16.31L6.87 20.08L2.04 21.14L3.1 16.31Z" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'pencil',
};
</script>

<style scoped>
.pencil{
  fill: currentColor;
}
</style>
